import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null); // null = unknown, false = signed out, object = signed in
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("concierge_admin_token");
        if (!token) {
            setAdmin(false);
            setLoading(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setAdmin(data);
        } catch {
            localStorage.removeItem("concierge_admin_token");
            setAdmin(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("concierge_admin_token", data.access_token);
            setAdmin({ email: data.email, role: data.role });
            return { ok: true };
        } catch (e) {
            return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem("concierge_admin_token");
        setAdmin(false);
    };

    return (
        <AuthCtx.Provider value={{ admin, loading, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
